import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from 'src/hooks';

// Services
import { createTherapyUseCase } from 'src/services/therapy/useCases';
// Components
import TherapyGeneralForm from 'src/components/forms/admin/therapy/TherapyGeneralForm';

const AddTherapy = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const TherapistDetailView = useAppSelector((state) => state.therapy.TherapistDetailView);
  const handleSuccess = (values: any) => {
    const postCoachGeneralInfo = Object.assign({}, values);
    if (!values.location?.stateId) {
      delete postCoachGeneralInfo?.location;
    }
    if (!values.description) {
      delete postCoachGeneralInfo?.description;
    }
    if (!values.shortDescription) {
      delete postCoachGeneralInfo?.shortDescription;
    }
    dispatch(createTherapyUseCase(postCoachGeneralInfo));
  };

  useEffect(() => {
    if (TherapistDetailView === 'additional-info') {
      navigate('additional-info');
    }
  }, [TherapistDetailView, navigate]);

  return <TherapyGeneralForm onSuccess={handleSuccess} isEditing={false} />;
};

export default AddTherapy;
